import { useSyncExternalStore } from 'react';

// NAV-FE-1c — the path a record page hands to the shell's ONE breadcrumb.
//
// `parts` = [{ label, to? }], the steps AFTER the project: `Handover › HI-0003`,
// `NCRs › NCR-012`. A part with `to` is a link (the way back); one without is
// where you are. Empty = the shell shows `{project} › {active item}`.
//
// Why a module store and not a Provider: every page renders its OWN <Layout>,
// so a Provider inside the Layout would sit below the page that writes to it,
// and the only place above every page is App.js. The store is read through
// useSyncExternalStore, so the shell re-renders when a page sets or clears it.
// A page sets its parts in an effect when its data arrives, and clears them in
// that effect's cleanup.

const EMPTY = [];
let current = EMPTY;
const listeners = new Set();

const sameParts = (a, b) => a.length === b.length
  && a.every((p, i) => p.label === b[i].label && (p.to || null) === (b[i].to || null));

const emit = () => listeners.forEach((listener) => listener());

export function setCrumb(parts) {
  const next = Array.isArray(parts)
    ? parts.filter((p) => p && p.label).map((p) => (p.to ? { label: String(p.label), to: p.to } : { label: String(p.label) }))
    : EMPTY;
  if (sameParts(next, current)) return;
  current = next.length ? next : EMPTY;
  emit();
}

export function clearCrumb() {
  if (current === EMPTY) return;
  current = EMPTY;
  emit();
}

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
const getSnapshot = () => current;

/** The parts the shell shows, plus the two setters. */
export function useShellCrumb() {
  const parts = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  return { parts, setCrumb, clearCrumb };
}
